import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './edit.page.component.css';
import Button from 'component/button.component';
import {
  userLogout,
  userRegister,
  userUpdate,
  userUpdateImage,
} from 'store/action/user.action';
import Link from 'component/link.component';
import { Input, InputLabel, TextField, FormControl } from '@material-ui/core';
import oabNumberFormat from 'component/masks/oabNumberFormat.component';
import { toast } from 'react-toastify';
import { USER_UPDATE_ERROR, USER_UPDATE_SUCCESS } from 'config/constants';

class EditUser extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      oab: '',
      aaspKey: '',
      image: '',
      password_req: '',
      password_confirmation: '',
      showInputPassword: false,
    };
  }

  componentDidMount() {
    if (this.props.user) {
      const { email, name, oab, chave_acesso_aasp } = this.props.user;
      this.setState({
        email,
        name,
        oab,
        aaspKey: chave_acesso_aasp,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user !== nextProps.user) {
      const { email, name, oab, chave_acesso_aasp } = nextProps.user;
      this.setState({
        email,
        name,
        oab,
        aaspKey: chave_acesso_aasp,
      });
    }
  }

  _isLoading = false;

  _onChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  _onChangeOAB = event => this.setState({ oab: event.currentTarget.value });

  _onChangePasswordReq = event =>
    this.setState({ password_req: event.currentTarget.value });

  _onChangePasswordReqConfirmation = e =>
    this.setState({ password_confirmation: e.currentTarget.value });

  _userLogout = () => {
    this.props.userLogout();
    this.props.history.push('/');
  };

  _userUpdate = () => {
    const { name, password_req, password_confirmation, aaspKey } = this.state;
    let { oab } = this.state;
    const { id, email } = this.props.user;
    if (!(name || oab || password_req)) {
      toast.error('Realize uma alteração em um dos campos para continuar.');
      return;
    }

    if (name.trim() === '') {
      toast.error('Nome não deve ser vazio.');
      return;
    }

    if (oab !== '' && oab !== null) {
      if (oab.includes('_')) {
        toast.error('Nº da OAB inválido.');
        return;
      }
      oab = oab.toUpperCase();
    }

    if (password_req !== password_confirmation) {
      toast.error('Senhas devem ser iguais.');
      return;
    }

    let user = {
      email,
      name,
      oab,
      chave_acesso_aasp: aaspKey,
    };

    if (password_req && password_req !== '') {
      user = {
        ...user,
        password_req,
        password_confirmation,
      };
    }

    this.props
      .userUpdate(user, id)
      .then(({ type, message }) => {
        if (type === USER_UPDATE_SUCCESS) {
          toast.success('Usuário atualizado com sucesso!');
          this.props.history.push('/');
        } else if (type === USER_UPDATE_ERROR) {
          toast.error(message);
        }
      })
      .catch(error => {
        console.error('Erro: ', error);
        toast.error('Por favor, entre em contato com o suporte.');
      });
  };

  _onChangeUserImage = event => {
    const { id } = this.props.user;

    this.props
      .userUpdateImage(event.currentTarget.files[0], id)
      .then(response => {
        toast.success('Imagem atualizada com sucesso!');
      })
      .catch(error => {
        console.error('Erro: ', error);
        toast.error('Por favor, entre em contato com o suporte.');
      });
  };

  render() {
    const {
      name,
      email,
      oab,
      aaspKey,
      password_req,
      password_confirmation,
      showInputPassword,
    } = this.state;
    const { user } = this.props;
    return (
      <>
        <Helmet>
          <title>Perfil Usuário Juslabore</title>
          <meta
            name="description"
            content="Edite seu perfil na plataforma Juslabore"
          />
        </Helmet>
        <div className="flex-column align-stretch">
          <div
            style={{ padding: 50 }}
            className="register-page-container flex-column align-stretch self-align-center"
          >
            <label
              htmlFor="edit-logo-img-input"
              className="flex-column align-center justify-center"
            >
              <span
                className="edit-logo-img flex-column self-align-center relative component-focus"
                style={{ width: 120, height: 120, borderRadius: '50%' }}
              >
                {user && !user.image ? (
                  <span
                    className="flex-row align-center justify-center"
                    style={{
                      width: '100%',
                      height: '100%',
                      borderRadius: '50%',
                      backgroundColor: '#AAAAAA',
                      fontWeight: 'bold',
                    }}
                  >
                    {user.name.substr(0, 1).toUpperCase()}
                  </span>
                ) : (
                  <img
                    src={user ? user.image : null}
                    style={{
                      width: '100%',
                      height: '100%',
                      borderRadius: '50%',
                    }}
                    alt={'imagem do usuário'}
                  />
                )}
              </span>
            </label>
            <input
              id="edit-logo-img-input"
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={this._onChangeUserImage}
            />
            <div className="edit-content flex-column align-stretch">
              <h4 className="self-align-center" style={{ color: '#000' }}>
                Informações pessoais
              </h4>
              <TextField
                label="E-mail"
                name="email"
                value={email || (user ? user.email : '')}
                disabled
              />
              <TextField
                label="Nome"
                name="name"
                value={name}
                onChange={this._onChange}
              />
              <FormControl fullWidth>
                <InputLabel htmlFor="userOAB">Nº. OAB</InputLabel>
                <Input
                  id="userOAB"
                  inputComponent={oabNumberFormat}
                  name="userOAB"
                  value={oab}
                  onChange={this._onChangeOAB}
                />
              </FormControl>
              <TextField
                label="Chave AASP"
                name="aaspKey"
                value={aaspKey}
                onChange={this._onChange}
              />
              {showInputPassword && (
                <>
                  <Input
                    inputProps={{
                      placeholder: 'Senha',
                      value: password_req,
                      onChange: this._onChangePasswordReq,
                      type: 'password',
                    }}
                  />
                  <Input
                    inputProps={{
                      placeholder: 'Confirmação de Senha',
                      value: password_confirmation,
                      onChange: this._onChangePasswordReqConfirmation,
                      type: 'password',
                    }}
                  />
                </>
              )}
              {user && !['GOOGLE', 'FACEBOOK'].includes(user.login_type) && (
                <Link
                  className="relative component-focus"
                  onClick={() =>
                    this.setState({ showInputPassword: !showInputPassword })
                  }
                  text={showInputPassword ? 'Cancelar' : 'Alterar senha'}
                  style={{ color: '#1a73e8', margin: '20px 15px 0' }}
                />
              )}
            </div>

            <Button
              className="self-align-stretch align-center justify-center"
              text="SALVAR"
              style={{
                backgroundColor: '#185335',
                marginTop: 30,
                marginRight: 15,
              }}
              onClick={this._userUpdate}
            />
            <Link
              className="component-focus self-align-center"
              onClick={this._userLogout}
              text="SAIR"
              style={{ color: '#1a73e8', margin: '20px 15px 0' }}
            />
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({ user }) {
  return {
    user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userRegister: user => dispatch(userRegister(user)),
    userLogout: () => dispatch(userLogout()),
    userUpdate: (user, id) => dispatch(userUpdate(user, id)),
    userUpdateImage: (file, id) => dispatch(userUpdateImage(file, id)),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditUser)
);
